exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-enter-active[data-v-60b69510],.collapse-leave-active[data-v-60b69510]{transition:all .2s;max-height:500px}.collapse-enter[data-v-60b69510],.collapse-leave-to[data-v-60b69510]{opacity:0;max-height:0}.nav-link[data-v-60b69510]{color:rgba(0,0,0,.6);padding:-1em 0}.disabled[data-v-60b69510]{color:rgba(0,0,0,.2)}.nav-link.active[data-v-60b69510]{font-weight:700;padding:-1em 0}.nav-link.disabled[data-v-60b69510]{color:rgba(0,0,0,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60b69510","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/course/CourseNavigation.vue
// module id = 224
// module chunks = 0